export function convertPhase(phaseId: string) {
    const converted = phaseId == "2" || phaseId == "3" ? "1" :
        phaseId == "8" || phaseId == "9" ? "4" :
            phaseId == "6" || phaseId == "7" ? "5" :
                phaseId + ""

    return converted
}